import { MultiSelect } from "primereact/multiselect"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { updateState } from "../../../utils/utils"
import { ListBox } from "primereact/listbox"

const SubstanceUseMultiSelectRow = (props) => {
  const {
    legend,
    value,
    setValue,
    removeError,
    disabled,
    error,
    errorType,
    options,
    removeErrors,
    entity,
    setEntity,
    summary,
  } = props
  const getListBoxValues = () => {
    return value.length === 0 ? ["None"] : value
  }
  return (
    <>
      <div className={gpraStyles.formLabel}>
        <label>{legend}</label>
      </div>
      {summary ? (
        <ListBox
          options={getListBoxValues()}
          disabled
          className={gpraStyles.input5}
        />
      ) : (
        <MultiSelect
          value={value}
          options={options}
          onChange={(e) => {
            updateState(setValue, e.value, null, null, entity, setEntity, null)
            removeError(errorType)
            if (removeErrors) {
              removeErrors.forEach((element) => {
                removeError(element)
              })
            }
          }}
          optionLabel="label"
          optionValue="value"
          showSelectAll={false}
          showClear={true}
          disabled={disabled}
          className={error ? gpraStyles.input5Error : gpraStyles.input5}
          maxSelectedLabels={3}
        />
      )}

      <FormError error={error} />
    </>
  )
}

export default SubstanceUseMultiSelectRow
